import { render, staticRenderFns } from "./XP.vue?vue&type=template&id=314d8bd8&scoped=true"
import script from "./XP.vue?vue&type=script&lang=js"
export * from "./XP.vue?vue&type=script&lang=js"
import style0 from "./XP.vue?vue&type=style&index=0&id=314d8bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d8bd8",
  null
  
)

export default component.exports